module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/57.d7540f90.png";